var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransenergopromLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 80,
    viewBox: "0 0 300 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_3079)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.894 29.4259C16.999 27.715 13.5266 27.3037 10.3098 28.2826C7.81066 31.1862 6.30127 34.9618 6.30127 39.0828C6.30127 39.1897 6.30127 39.2967 6.30127 39.4036L24.8181 31.2191C23.8119 29.5493 21.6096 30.4377 19.894 29.4259Z",
    fill: "#5DC5EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2234 30.6105C34.3201 25.7573 29.0084 22.5 22.9296 22.5C17.89 22.5 13.3618 24.7538 10.3101 28.2826C13.5185 27.312 17.0075 27.7233 19.8943 29.426C20.4552 29.755 20.983 30.1334 21.4779 30.5447C23.1275 31.9183 24.0348 33.9912 24.0348 36.1298V37.2403H38.5101L45.158 30.6105H37.2152H37.2234Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2722 50.5658C28.1673 52.2767 31.6397 52.688 34.8565 51.7092C37.3556 48.8055 38.865 45.03 38.865 40.9089C38.865 40.802 38.865 40.6951 38.865 40.5881L20.3481 48.7726C21.3544 50.4424 23.5566 49.5541 25.2722 50.5658Z",
    fill: "#5DC5EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.272 50.5658C24.7111 50.2368 24.175 49.8584 23.6884 49.4471C22.0388 48.0734 21.1315 46.0006 21.1315 43.8619V42.7515H6.64792L0 49.3895H7.94287C10.8462 54.2427 16.1579 57.5 22.2367 57.5C27.2763 57.5 31.8045 55.2462 34.8562 51.7174C31.6477 52.688 28.1588 52.2767 25.272 50.574V50.5658Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.331 37.0346C121.444 37.0346 122.591 37.413 123.284 37.8901V34.2133C122.17 33.7115 120.884 33.4647 119.597 33.4647C116.157 33.4647 112.718 35.3731 112.734 40.1275C112.734 44.6845 116.157 46.5352 119.704 46.5352C121.032 46.5352 122.261 46.2885 123.374 45.7867V42.0194C122.731 42.5869 121.527 42.916 120.24 42.916C118.591 42.916 116.982 42.0934 116.982 40.1275C116.982 37.8983 118.615 37.0346 120.331 37.0346Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7476 46.2473H101.88V41.8055H106.227V46.2473H110.342V33.7444H106.227V38.1944H101.88V33.7444H97.7476V46.2473Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2422 46.2473H73.325V43.3519H76.0551C78.7109 43.3519 80.8719 41.1968 80.8719 38.5481C80.8719 35.8995 78.7109 33.7444 76.0551 33.7444H69.2422V46.2473ZM75.6179 37.1745C76.3767 37.1745 76.9953 37.7914 76.9953 38.5399C76.9953 39.2885 76.3767 39.9136 75.6179 39.9136H73.325V37.1745H75.6179Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.641 46.2473V33.7444H213.096V46.2473H217.212V37.3554H221.526V46.2473H225.641Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.681 40.5141L265.743 43.7138H267.913L269.966 40.5305V46.2473H274V33.7444H270.329L266.816 39.2144L263.327 33.7444H259.656V46.2473H263.681V40.5141Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.501 33.7444V46.2473H233.584V43.3519H236.314C238.97 43.3519 241.131 41.1968 241.131 38.5481C241.131 35.8995 238.97 33.7444 236.314 33.7444H229.501ZM235.877 37.1745C236.636 37.1745 237.255 37.7914 237.255 38.5481C237.255 39.3049 236.636 39.9218 235.877 39.9218H233.584V37.1827H235.877V37.1745Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.072 46.6998C253.776 46.6998 256.786 43.6974 256.786 40.0041C256.786 36.3108 253.776 33.3085 250.072 33.3085C246.369 33.3085 243.358 36.3108 243.358 40.0041C243.358 43.6974 246.369 46.6998 250.072 46.6998ZM250.072 37.0758C251.631 37.0758 252.893 38.3919 252.893 40.0041C252.893 41.6163 251.631 42.9324 250.072 42.9324C248.513 42.9324 247.251 41.6163 247.251 40.0041C247.251 38.3919 248.513 37.0758 250.072 37.0758Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.641 43.1051C129.436 43.1051 128.224 42.8172 127.523 42.2332V45.7867C128.636 46.2885 129.865 46.5352 131.103 46.5352C134.649 46.5352 138.072 44.6762 138.072 40.1275C138.089 35.3731 134.649 33.4647 131.21 33.4647C129.923 33.4647 128.628 33.7115 127.523 34.2133V37.6927C128.274 37.1909 129.494 36.8537 130.624 36.8537C132.109 36.8701 133.404 37.2896 133.882 38.6715H129.329V41.4024H133.915C133.396 42.6363 132.142 43.0969 130.641 43.0969V43.1051Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.553 46.2473H145.685V41.8055H150.032V46.2473H154.147V33.7444H150.032V38.1944H145.685V33.7444H141.553V46.2473Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.054 42.9653H162.585V41.4847H167.295V38.4412H162.585V37.0017H167.947V33.7444H158.453V46.2473H168.054V42.9653Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.274 46.2473H190.414V37.3554H195.677V33.7444H186.274V46.2473Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.644 33.7444H171.832V46.2473H175.914V43.3519H178.644C181.3 43.3519 183.461 41.1968 183.461 38.5481C183.461 35.8995 181.3 33.7444 178.644 33.7444ZM178.207 39.9218H175.914V37.1827H178.207C178.966 37.1827 179.585 37.7996 179.585 38.5481C179.585 39.2967 178.966 39.9218 178.207 39.9218Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.999 46.6998C207.702 46.6998 210.712 43.6974 210.712 40.0041C210.712 36.3108 207.702 33.3085 203.999 33.3085C200.295 33.3085 197.285 36.3108 197.285 40.0041C197.285 43.6974 200.295 46.6998 203.999 46.6998ZM203.999 37.0758C205.557 37.0758 206.819 38.3919 206.819 40.0041C206.819 41.6163 205.557 42.9324 203.999 42.9324C202.44 42.9324 201.178 41.6163 201.178 40.0041C201.178 38.3919 202.44 37.0758 203.999 37.0758Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9531 46.2473H63.0069V37.3554H66.6855V33.7444H60.9531H55.2207V37.3554H58.8911V46.2473H60.9531Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4414 46.2473L85.994 44.5857H90.3078L90.8604 46.2473H95.0504L90.3573 33.7444H85.9363L81.2432 46.2473H85.4332H85.4414ZM89.3097 41.5998H86.9921L88.1468 38.1369L89.3097 41.5998Z",
    fill: "#283581"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_3079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 35,
    fill: "white",
    transform: "translate(0 22.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransenergopromLogo);
export default __webpack_public_path__ + "static/media/transenergoprom_logo.f2027834c224a266b0e9c4ac29b99191.svg";
export { ForwardRef as ReactComponent };